import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import { transitions } from './transitionsCompNode'
import { transitionsVariants } from './transitionsVariantsCompNode'
import type { TransitionsCssFeature } from './transitions.types'
import { transitionsDomApplier } from './transitionsDomApplier'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'

export const transitionsCssFeature: TransitionsCssFeature = {
	featureName: 'transitions',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { transitionsVariants, transitions },
	intermediateNodes: {},
	dataMaps: ['variants_data', 'transitions_data'],
	domApplier: transitionsDomApplier,
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(transitionsCssFeature)
}
export const editor: BindFeature = page
